// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2zR9Z","textarea":"styles_textarea__13v5S"};